"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auctionHandler = void 0;
var ConsentHandler_1 = require("./consent/ConsentHandler");
var Auction_1 = __importDefault(require("./Auction"));
var UserSync_1 = require("./UserSync");
var __1 = require("..");
var log_1 = require("../utils/log");
var AuctionHandler = /** @class */ (function () {
    function AuctionHandler() {
        this.queued_auction = null;
        this.active_auctions = new Map();
        this.finished_auctions = new Map();
        this.timout = null;
    }
    AuctionHandler.prototype.initNewAuction = function () {
        // check if auction is already queued
        if (!this.queued_auction) {
            // create new auction
            this.queued_auction = new Auction_1.default();
        }
        return this.queued_auction;
    };
    AuctionHandler.prototype.addSlotsToAuction = function (slots) {
        var queued_auction = this.queued_auction || this.initNewAuction();
        queued_auction.addSlotsToAuction(slots);
        return queued_auction;
    };
    AuctionHandler.prototype.sendAuctionRequest = function (delay) {
        var _this = this;
        if (delay === void 0) { delay = 100; }
        if (this.queued_auction) {
            if (this.timout) {
                clearTimeout(this.timout);
                this.timout = null;
            }
            // Queue commands for execution when consent is ready
            ConsentHandler_1.allConsentHandler.cmd.push(function () {
                if (ConsentHandler_1.allConsentHandler.checkIfMissing()) {
                    (0, log_1.logInfo)("AuctionHandler: Missing Consent");
                    ConsentHandler_1.allConsentHandler.loadIfMissing(function () {
                        (0, log_1.logInfo)("AuctionHandler: Load If Missing Callback");
                        // Sync users
                        UserSync_1.globalUserSync.syncUsers(__1.globalSettings.user_syncs, __1.globalSettings.bidders);
                        // TODO: Run Indentity Adapters
                        // init auction
                        _this.queued_auction.init();
                        _this.send();
                    });
                }
                else {
                    _this.queued_auction.init();
                    if (delay) {
                        _this.timout = setTimeout(function () {
                            _this.send();
                        }, delay);
                    }
                    else {
                        _this.send();
                    }
                }
            });
        }
    };
    AuctionHandler.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, log_1.logInfo)("AuctionHandler: send");
                        if (!UserSync_1.globalUserSync.ready) return [3 /*break*/, 3];
                        if (!this.queued_auction) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.queued_auction.sendAuctionRequest()];
                    case 1:
                        success = _a.sent();
                        if (success) {
                            this.active_auctions.set(this.queued_auction.id, this.queued_auction);
                        }
                        this.queued_auction = null;
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        UserSync_1.globalUserSync.callback = this.send.bind(this);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuctionHandler.prototype.auctionFinished = function (auction) {
        this.active_auctions.delete(auction.id);
        this.finished_auctions.set(auction.id, auction);
    };
    return AuctionHandler;
}());
exports.auctionHandler = new AuctionHandler();
